import { createContext } from 'react';

/**
 * Provides the id of the Custom Homepage content module a content card is
 * rendered within, merged into the card's analytics traits as `module_id` so
 * Intelligence can map the module id to its name in reporting.
 *
 * Only real content modules provide it: the legacy recommended/newest/popular
 * sections have no module record behind them and stay identified by their
 * `location` trait alone.
 *
 * Defaults to `undefined` — off the custom homepage no provider is present, so
 * nothing is inherited from the surrounding tree.
 */
export const CustomHomepageModuleContext = createContext<string | undefined>(
  undefined
);
